import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import css from './App.scss';
import Menu from 'src/components/Menu/Menu';
import * as core from 'cw-ui-core';
import FramedScreen from "src/components/FramedScreen/FramedScreen";
import getScreen from 'src/ScreenFactory';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.cachedFrames = {};
    this.previousRoute = location.pathname;
    this.queryParam = location.search;
    this.ROUTES = [
      {
        id: 'home',
        exact: true,
        path: '/',
        logo: core.IconPath.get('Application_CW_Today'),
        isInlineSVG: true,
        src: props.partnerPortalUrl + '/home',
        showInMenu: true
      },
      {
        id: 'add-licenses-id',
        path: '/addlicenses',
        src: props.partnerPortalUrl + '/addlicenses',
        showInMenu: false
      },
      {
        id: 'unite',
        exact: true,
        name: 'UNITE',
        path: '/unite',
        logo: '/unite.png',
        isInlineSVG: false,
        src: props.partnerPortalUrl + '/productsStore/CW%20Unite',
        showInMenu: true
      },
      {
        id: 'unite-id',
        path: '/unite/:id',
        src: props.partnerPortalUrl + '/productsStore/CW%20Unite',
        showInMenu: false
      },
      {
        id: 'productsStore-unite',
        exact: true,
        path: '/productsStore/unite',
        src: props.partnerPortalUrl + '/productsStore/CW%20Unite',
        showInMenu: false
      },
      {
        id: 'productsStore-unite-id',
        path: '/productsStore/unite/:id',
        src: props.partnerPortalUrl + '/productsStore/CW%20Unite',
        showInMenu: false
      },
      {
        id: 'control',
        exact: true,
        name: 'CONTROL',
        path: '/control',
        logo: '/control.png',
        isInlineSVG: false,
        src: props.partnerPortalUrl + '/productsStore/Control',
        showInMenu: props.showControl
      },
      {
        id: 'control-id',
        path: '/control/:id',
        src: props.partnerPortalUrl + '/productsStore/Control',
        showInMenu: false
      },
      {
        id: 'identify',
        exact: true,
        name: 'IDENTIFY',
        path: '/identify',
        logo: '/identify.png',
        isInlineSVG: false,
        src: props.partnerPortalUrl + '/productsStore/Identify',
        showInMenu: true
      },
      {
        id: 'identify-id',
        path: '/identify/:id',
        src: props.partnerPortalUrl + '/productsStore/Identify',
        showInMenu: false
      },
      {
        id: "university",
        name: "UNIVERSITY",
        path: "/university",
        logo: '/university_assets/university.svg',
        isInlineSVG: true,
        showInMenu: true,
        isComponent: true,
        component: (props) => getScreen('university', props),
      },
      {
        id: 'settings',
        exact: true,
        name: 'SETTINGS',
        path: '/settings',
        logo: core.IconPath.get('Menu_Settings'),
        isInlineSVG: true,
        src: props.stsUserAdminUrl,
        showInMenu: true
      },
      {
        id: 'settings-id',
        path: '/settings/:id',
        src: props.stsUserAdminUrl,
        showInMenu: false
  
      },
      {
        id: 'payments',
        path: '/payments',
        src: props.partnerPortalUrl + '/payments',
        showInMenu: false
      },
      {
        id: 'shopping-cart',
        path: '/shoppingCart',
        isComponent: true,
        component: (props) => getScreen('shoppingcart', props),
        showInMenu: false
      }
    ];
  }

  getCachedFrame = (route) => {
    let cached = this.cachedFrames[route.id];

    if (!cached) {
      cached = () => {
        // queryParam was added here to pass query params to the iFrame and to be removed after they are used once.
        if(this.previousRoute !== location.pathname){
          this.queryParam = undefined;
        }
        this.previousRoute = location.pathname;
        return <FramedScreen onShowMenuChanged={this.props.onShowMenuChanged} src={route.src} search={this.queryParam} />;
      };
      this.cachedFrames[route.id] = cached;

    }
    return cached;
  };

  getComponent = (route) => {
    const callback = (props)=> { 
      this.previousRoute = location.pathname;
        return  route.component(props) ;
      };
    return callback;
  };

  render() {
    return (
      <Router>
        <div className={css.wrap}>
          {this.props.showMenu ? <Menu className={css.menu} items={this.ROUTES} />: null}
          <div className={css.content}>
            {this.ROUTES.map((route) => {
              return (
                <Route key={route.id} exact={route.exact} path={route.path} render={route.isComponent ? this.getComponent(route) : this.getCachedFrame(route)} />
              );
            })}
          </div>
        </div>
      </Router>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App/App.jsx